import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllTournamentIdsMustMatch: RuleHandler = (context, requirement) => {
  if (
    !setIncludes(
      new Set(requirement.userDrivenAttributes?.tournamentIds),
      new Set(context.selection.tournamentIds),
      requirement.userDrivenAttributes?.allTournamentIdsMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllTournamentIdsMustMatch };
